import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { useSignInForm } from "@/hooks/use-sign-in-form";
import { useTranslations } from "@/i18n/hooks";
import { FloatingLanguageSelector } from "@/components/FloatingLanguageSelector";

const CoachSignIn = () => {
  const t = useTranslations('coach');
  const { 
    email, 
    setEmail, 
    password, 
    setPassword, 
    loading, 
    handleSubmit 
  } = useSignInForm('specialist');

  return (
    <div className="min-h-screen bg-black text-white p-6">
      <div className="flex justify-between items-start">
        <Link to="/" className="inline-flex items-center text-gray-400 hover:text-white">
          <ArrowLeft className="w-4 h-4 mr-2" />
          {t('signIn.backToHome')}
        </Link>
        <FloatingLanguageSelector />
      </div>

      <div className="max-w-md mx-auto space-y-6 mt-12">
        <div className="text-center space-y-2">
          <h1 className="text-3xl font-bold">{t('signIn.title')}</h1>
          <p className="text-gray-400">{t('signIn.subtitle')}</p>
        </div>

        <form onSubmit={handleSubmit} className="space-y-6">
          <div className="space-y-2">
            <label htmlFor="email" className="block">
              {t('signIn.email.label')}
            </label>
            <Input
              id="email"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="w-full bg-gray-900 border-gray-800 text-white"
              placeholder={t('signIn.email.placeholder')}
              required
            />
          </div>

          <div className="space-y-2">
            <label htmlFor="password" className="block">
              {t('signIn.password.label')}
            </label>
            <Input
              id="password"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="w-full bg-gray-900 border-gray-800 text-white"
              placeholder={t('signIn.password.placeholder')}
              required
            />
            <div className="text-right">
              <Link to="/coach-forgot-password" className="text-sm text-gray-400 hover:text-white">
                {t('signIn.forgotPassword')}
              </Link>
            </div>
          </div>

          <Button
            type="submit"
            className="w-full bg-purple-600 text-white hover:bg-purple-700"
            disabled={loading}
          >
            {loading ? t('signIn.submitButton.loading') : t('signIn.submitButton.default')}
          </Button>
        </form>

        <div className="text-center text-gray-400">
          {t('signIn.registerPrompt.text')}{" "}
          <Link to="/specialist-registration" className="text-purple-400 hover:text-purple-300">
            {t('signIn.registerPrompt.link')}
          </Link>
        </div>
      </div>
    </div>
  );
};

export default CoachSignIn;
